module.exports = __webpack_public_path__ + "img/view.c3abb2ef.svg";